module.exports = __webpack_public_path__ + "static/img/12.8e81c11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/12.png
// module id = v5KC
// module chunks = 0